
import React, { memo } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CloudDownload from '@material-ui/icons/CloudDownload'
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import green from '@material-ui/core/colors/green';
// core components
import Success from "src/components/Typography/Success.jsx";
import Warning from "src/components/Typography/Warning.jsx";
import Danger from "src/components/Typography/Danger.jsx";
import GridContainer from "src/components/Grid/GridContainer.jsx";
import GridItem from "src/components/Grid/GridItem.jsx";
import CustomInput from "src/components/CustomInput/CustomInput.jsx";
import Button from "src/components/CustomButtons/Button.jsx";
import Card from "src/components/Card/Card.jsx";
import CreditIcon from "@material-ui/icons/AccountBalanceWallet"
import CardHeader from "src/components/Card/CardHeader.jsx";
import CardText from "src/components/Card/CardText.jsx";
import CardIcon from "src/components/Card/CardIcon.jsx";
import CardBody from "src/components/Card/CardBody.jsx";
import CardFooter from "src/components/Card/CardFooter.jsx";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import customSelectStyle from "src/assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import { cardTitle } from "src/assets/jss/material-dashboard-pro-react.jsx";
import ImageUpload from "src/components/CustomUpload/ImageUpload.jsx";
import * as model from '../../data/model';
import * as dal from '../../data/dal';
import SnackbarContent from "src/components/Snackbar/SnackbarContent.jsx";
import * as types from '../../types'
import { SSL_OP_NETSCAPE_CA_DN_BUG } from "constants";
import * as firebase from 'firebase/app';
import { TableBody } from "@material-ui/core";
import Table from "../../components/Table/Table"
import TableHead from "@material-ui/core/TableHead";
import CustomTable from "src/components/Table/Table.jsx";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import CircularProgress from "@material-ui/core/CircularProgress";
import PaymentButton from '../../custom_components/Payment'
let moment = require('moment')
import {
    defaultFont,
    primaryColor,
    infoColor,
    successColor,
    warningColor,
    dangerColor
} from "src/assets/jss/material-dashboard-pro-react.jsx";
import { debug } from "util";

const styles : any = theme => ({
    cardTitle: {
        ...cardTitle,


    },
    cardText: {
        backgroundColor: 'white',
    },
    cardTitleWhite: {
        ...cardTitle,



    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px"
    },
    cardCategoryWhite: {
        margin: "0",
        color: "rgba(0, 0, 0, 0.8)",
        fontSize: ".875rem"
    },
    ...customSelectStyle,
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    button: {
        margin: theme.spacing.unit,
        float: "right",
    },

    successText: {
        color: successColor,
        paddingRight: '5px',
        paddingLeft: '5px'
    },
    warningText: {
        color: warningColor,
        paddingRight: '5px',
        paddingLeft: '5px'
    },
    dangerText: {
        color: dangerColor
    },
    tableCell: {
        whiteSpace: 'nowrap',
      }

});

interface TrackViewProps {
    classes: any;
    connect: types.IState
}
interface TrackViewState {
    transactionHistory: types.LoadingObject<Array<model.Transaction>>
}
class TrackView extends React.Component<TrackViewProps, TrackViewState> {
    callback: dal.UpdateCallback<model.Transaction>;
  
    constructor(props: TrackViewProps) {
        super(props);

        this.state = {
            transactionHistory: new types.LoadingObject<Array<model.Transaction>>()

        };
        let me = this;
        let func = async function () {
            let transactionUpdated = function (transactions: Array<model.Transaction>) {
                let s = { ...me.state };
                
                s.transactionHistory.setCompleted(transactions.sort((a: model.Transaction, b: model.Transaction): any => {
                    return a.created > b.created ? -1 : 1
                }));
                
                me.setState(s);
            } 
            me.callback = new dal.UpdateCallback<model.Transaction>("transactions", null, transactionUpdated)
            let transactions = await me.props.connect.lo_ctx.val().Transaction.list(me.callback);
            transactionUpdated(transactions)
        }
        func();
    }

    render() {
        const { classes } = this.props;
        let me = this;
        if (this.state.transactionHistory.loadingState == types.LoadingState.NotLoaded) {

        }
        //this.props.match.params

        let typeToString = function (t: model.TransactionType): string {
            ;
            switch (t) {
                case (model.TransactionType.addCredit): return "Credits Added";
                case (model.TransactionType.purchaseCredits): return "Purchased Credits";
                case (model.TransactionType.useCreditsOnTrack): return "Track";
                case (model.TransactionType.addCredit): return "Credits Added";
                case (model.TransactionType.refund): return "Refund";
                default: return "Unkown"
            }
        }
        let formatMoney = function (cc,n, c, d, t) {
            var c = isNaN(c = Math.abs(c)) ? 2 : c,
                d = d == undefined ? "." : d,
                t = t == undefined ? "," : t,
                s = n < 0 ? "-" : "",
                i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                j = (j = i.length) > 3 ? j % 3 : 0;
            //@ts-ignore
            let retval =  s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
           if(cc)
            return retval+' '+cc;
        else 
            return retval;
        };
        let credits = "...";
        if (this.props.connect.lo_CustomerBalance.completed()) {
            credits = this.props.connect.lo_CustomerBalance.val().credits.toString()
        }
        let tableData = [];
        if(this.state.transactionHistory.completed()  )
        {
           
            tableData = this.state.transactionHistory.val().map(t => {
                return [moment(t.created).calendar(), t.description,typeToString(t.transaction_type),formatMoney(t.amount_currency_code,t.amount,null,null,null),t.credits]
           })
        } 
        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <CardIcon color="rose">
                                <CreditIcon />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>  Your Credit Balance is {credits}</h4>


                        </CardHeader>
                        <CardBody>

<div style={{    display: 'table',
    margin: '0 auto'}}>
                             <PaymentButton />
                             </div>
                             <Table
             
             tableHead={["Date", "Description", "Type", "Amount", "Credits"] as any}
              tableData={tableData as any}

            />
                          
                        </CardBody>

                    </Card>
                </GridItem>
            </GridContainer >
        );
    }
}

export function mapStateToProps(state: types.IState) {
    return {
        connect: state
    };
}
export default connect(
    mapStateToProps,
    null
)(withStyles(styles as any)(TrackView));



/*


<form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
<input type="hidden" name="cmd" value="_s-xclick">
<input type="hidden" name="hosted_button_id" value="49N4PALTFNL46">
<input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!">
<img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1">
</form>
*/




// WEBPACK FOOTER //
// ./src/views/credits/Credits.tsx